import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';

const ToolSurveyPageResult: React.FC<ToolSurveyPageResultProps> = ({isLoading}) => {

  React.useEffect(() => {
  }, []);

  if (isLoading)
    return <div className="loader"></div>

  return <>
  </>
};

const mapStateToProps = (state: AppState) => ({
  isLoading: true
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolSurveyPageResult);

type ToolSurveyPageResultProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>